import Inspector from './inspector';
const { RichText } = wp.blockEditor;

const Edit = ({ attributes, setAttributes }) => {
  const { title, image, icon, description, subDescription, button, margin } =
    attributes;

  return (
    <>
      <Inspector attributes={attributes} setAttributes={setAttributes} />

      <section className={`SectionMap ${margin}`}>
        <div className="Container">
          <RichText
            tagName="h2"
            className="Typography title-4 left margin-medium color-blue-dark"
            value={title}
            placeholder="Title (h2)"
            keepPlaceholderOnFocus
            onChange={(title) => setAttributes({ title })}
          />
          <RichText
            tagName="p"
            className="Typography text left margin-base color-grey"
            value={description}
            placeholder="Text (p)"
            keepPlaceholderOnFocus
            onChange={(description) => setAttributes({ description })}
          />

          <div className="SectionMap-sep margin-base">
            <figure className="SectionMap-image">
              <img src={image.src} class="SectionMap-image" />
            </figure>
          </div>

          <RichText
            tagName="p"
            className="Typography text left margin-base color-grey"
            value={subDescription}
            placeholder="Text (p)"
            keepPlaceholderOnFocus
            onChange={(subDescription) => setAttributes({ subDescription })}
          />

          <div title="Button" className="Button ButtonPlans">
            <div>
              <figure className="SectionMap-icon">
                <img
                  src={icon.src}
                  title={icon.alt}
                  width={icon.width}
                  height={icon.height}
                  alt={icon.alt}
                  class="SectionMap-icon"
                />
              </figure>
            </div>

            <RichText
              tagName="p"
              value={button}
              placeholder="Texto do botão (a)"
              keepPlaceholderOnFocus
              onChange={(button) => setAttributes({ button })}
            />
          </div>
        </div>
      </section>
    </>
  );
};

export default Edit;
